import React, {FC} from 'react';
import {useClient} from "../redux/clients.hook";
import {Typography, TypographyProps} from "@material-ui/core";
import {getFullName} from "../../../utils";
import {Skeleton} from "@material-ui/lab";

interface ClientDisplayProps {
    clientId: string;
    typographyProps?: TypographyProps
}

export const ClientDisplay: FC<ClientDisplayProps> = ({clientId, typographyProps}) => {

    const {client} = useClient(clientId);

    return (
        <Typography variant="inherit" {...typographyProps}>
            {clientId && client ? `${getFullName(client)}${client.companyName ?  ` (${client.companyName})`: ""}` : <Skeleton width={150}/>}
        </Typography>
    )
}